import OperatingModeLookupPagingResultModelBase from '../_generated/modelBases/operating-mode-lookup-paging-result-model-base';

export default class OperatingModeLookupPagingResultModel extends OperatingModeLookupPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
